import Vue from 'vue'
import { commentNode } from '@/utils'
import store from '@/packages/vuex'

Vue.directive('click-outside', {
	bind,
	update (el, binding) {
		if (binding.value === binding.oldValue) return
		bind(el, binding)
	},
	unbind
})

const HANDLER = '_vue_clickaway_handler'

function bind (el, binding) {
	unbind(el)
	const callback = binding.value
	let initialMacrotaskEnded = false
	setTimeout(() => {
		initialMacrotaskEnded = true
	}, 0)
	el[HANDLER] = (ev) => {
		const path = ev.path || (ev.composedPath ? ev.composedPath() : undefined)
		if (initialMacrotaskEnded && (path ? path.indexOf(el) < 0 : !el.contains(ev.target))) {
			return callback(ev)
		}
	}
	document.documentElement.addEventListener('click', el[HANDLER], false)
}

function unbind (el) {
	document.documentElement.removeEventListener('click', el[HANDLER], false)
	delete el[HANDLER]
}

Vue.directive('can', (el, bindings, vnode) => {
	// if selected dep has permission
	if (!store.getters['Auth/user'].hasPermission(bindings.value)) {
		commentNode(el, vnode)
	}
})

Vue.directive('may', (el, bindings, vnode) => {
	// if any of deps have permission
	if (!store.getters['Auth/user'].hasSomePermission(bindings.value)) {
		commentNode(el, vnode)
	}
})

Vue.directive('testid', (el, bindings) => {
	if (bindings.value && (process.env.NODE_ENV === 'test' || process.env.VUE_APP_TEST_IDS === 'true')) {
		el.setAttribute('data-testid', bindings.value)
	}
})

Vue.directive('DynamicEvents',  {
	bind: (el, binding, vnode) => {
		const events = binding.value
		Object.keys(events).forEach((event) => {
			vnode.componentInstance.$on(event, (eventData) => {
				const _targetEvent = events[event]
				events[event](eventData)
				// vnode.context[targetEvent](eventData);
			})
		})
	},
	unbind: (el, binding, vnode) => {
		vnode.componentInstance.$off()
	}

})
